export default __webpack_public_path__ + "adf5213bbcc6f8608aeb30c7a245f144.webp";